import { faBasketShopping, faBedFront, faCar, faEllipsis, faFileInvoiceDollar, faForkKnife, faGasPump, faPlane, faPopcorn, faSpa, faUserHelmetSafety } from '@fortawesome/pro-regular-svg-icons';
export var spendingTrendsColors = {
    backgroundInfo: '#f3f4f5',
    backgroundTableHeader: '#f0f3f5',
    backgroundEmptyCategory: '#B1B1B1',
    default: '#244759'
};
export var spendingTrendsCategoryColors = {
    Airlines: '#58A7AF',
    'Bills & Utilities': '#C63527',
    'Contracted Services': '#AC5600',
    Entertainment: '#833799',
    Gas: '#FBC600',
    Grocery: '#3E8529',
    'Health & Beauty': '#2B5D1D',
    Lodging: '#CAA416',
    Other: '#400D01',
    Restaurants: '#D76B00',
    Transportation: '#34657F'
};
export var spendingTrendsCategoryIcons = {
    Airlines: faPlane,
    'Bills & Utilities': faFileInvoiceDollar,
    'Contracted Services': faUserHelmetSafety,
    Entertainment: faPopcorn,
    Gas: faGasPump,
    Grocery: faBasketShopping,
    'Health & Beauty': faSpa,
    Lodging: faBedFront,
    Other: faEllipsis,
    Restaurants: faForkKnife,
    Transportation: faCar
};
//# sourceMappingURL=spending-trends.js.map